import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b41507e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ❎ ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide material-icons-outlined" }, "playlist_remove", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["drawer primary", {open:_ctx.open}]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClose(false)))
      }, [
        (_ctx.displayClose)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["icon media-display", {'exited': (_ctx.scrollDirection > 0) }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClose(true)))
            }, _hoisted_3, 2))
          : _createCommentVNode("", true),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref: "container",
              class: "content",
              onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
            }, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ], 544))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 3
  }))
}